
import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class GetNotificationsPartnerResponse {
	constructor(private repository: PartnerSocketRepository) {}

	execute(callback: (data: any) => void): void {
		return this.repository.getNotificationsPartnerResponse(callback);
	}
}
